<div class="container">
<div class="text-center col-12 col-lg-10 col-xl-9 mx-auto py-4 py-md-5">
    <app-loading-indicator *ngIf="loading"></app-loading-indicator>
    <div *ngIf="!loading" class="mb-4">
        <h1 class="mb-4">Select a patient</h1>
      <p-dropdown
      styleClass="w-100 patient-select-dropdown"
      panelStyleClass="patient-select-dropdown-panel"
      [panelStyle]="{ width: '100%' }"
      appendTo="body"
      autoWidth="false"
      [style]="{ width: '100%' }"
      [options]="patientOptions"
      [disabled]="creatingService !== null"
      [ngModel]="selectedPatient?.ID"
      name="selectedPatientDropdown"
      id="selectedPatientDropdown"
      [showClear]="true"
      placeholder="Select a patient"
      [filter]="true"
      filterBy="searchString"
      optionLabel="FullName"
      optionValue="ID"
      [virtualScroll]="true"
      [virtualScrollItemSize]="50"
      (onChange)="changedPatient($event)"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.FullName }}</div>
          </div>
        </ng-template>
    </p-dropdown>

    </div>
    <section class="my-4 pt-4 border-top" aria-labelledby="myServicesHeading">
      <h2 id="myServicesHeading" class="h1 mb-4">My Opto Services</h2>
      <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mb-4">
        <label for="serviceDate" class="text-body-secondary flex-shrink-0">Service date</label>
        <input id="serviceDate" name="serviceDate" type="date" class="form-control flex-fill"
          [ngModel]="serviceDate" (ngModelChange)="loadServices($event)" [disabled]="isOffline || creatingService !== null" />
        <button type="button" class="btn btn-outline-primary flex-shrink-0" (click)="loadServices()"
          [disabled]="isOffline || servicesLoading || creatingService !== null">Refresh services</button>
      </div>
      @if (isOffline) {
        <p class="text-body-secondary bg-body-tertiary rounded-3 p-4 mb-0">Services are available when online. Use Offline Data to continue offline.</p>
      } @else if (servicesLoading) {
        <p class="text-body-secondary bg-body-tertiary rounded-3 p-4 mb-0" role="status">Loading services...</p>
      } @else if (servicesError) {
        <p class="text-danger bg-body-tertiary rounded-3 p-4 mb-0" role="alert">{{ servicesError }}</p>
      } @else if (services.length === 0) {
        <p class="text-body-secondary bg-body-tertiary rounded-3 p-4 mb-0" role="status">No Spark-enabled services in your schedule for this date.</p>
      } @else {
        <div class="table-responsive text-start border rounded-3">
          <table class="table table-striped table-hover align-middle mb-0">
            <caption class="text-center px-3">Services assigned to you for {{ serviceDate }}. Select a patient to continue.</caption>
            <thead class="table-light">
              <tr><th scope="col">Patient</th><th scope="col">Service</th><th scope="col">Time</th><th scope="col">Spark session</th></tr>
            </thead>
            <tbody>
              @for (service of services; track service.ID + ':' + service.PatientID) {
                <tr>
                  <td><button type="button" class="btn btn-link p-0" [disabled]="creatingService !== null" (click)="changedPatient({ value: service.PatientID! })">{{ service.PatientName }}</button></td>
                  <td><a [attr.href]="getServiceURL(service)" target="_blank" rel="noopener noreferrer">#{{ service.ID }} — {{ service.ServiceDescription }}</a></td>
                  <td>{{ service.StartTime | date : 'shortTime' }} – {{ service.EndTime | date : 'shortTime' }}</td>
                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <span class="text-nowrap">{{ service.LinkedSessionID ? 'Linked' : 'Not linked' }}</span>
                      @if (service.LinkedSessionID) {
                        <button type="button" class="btn btn-outline-primary btn-sm text-nowrap"
                          [disabled]="!service.CanOpenLinkedSession || creatingService !== null"
                          [title]="service.SessionActionUnavailableReason || 'Open linked Spark session'"
                          (click)="openLinkedSession(service)">Open session</button>
                      } @else if (service.ShowCreateSession) {
                        <button type="button" class="btn btn-success btn-sm rounded-circle"
                          [attr.aria-label]="'Create Spark session for service #' + service.ID"
                          [title]="service.SessionActionUnavailableReason || 'Create Spark session'"
                          [disabled]="!service.CanCreateSession || creatingService !== null"
                          (click)="createSessionForService(service)">
                          <i [class]="creatingService === service ? 'pi pi-spin pi-spinner' : 'pi pi-plus'" aria-hidden="true"></i>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
    <button class="btn btn-primary mt-2 px-4" [disabled]="creatingService !== null" (click)="goToOfflineData()">
      Offline Data
    </button>
  </div>
</div>
